<template>
  <v-dialog v-model="dialog" max-width="650" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-on="on" v-bind="attrs" text rounded>Detalhes</v-btn>
    </template>
    <v-card>
      <v-card-title class="font-weight-bold primary white--text"
        >Cálculo detalhado</v-card-title
      >
      <v-card-text>
        <v-row class="mt-3">
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <p>
                  <strong>Passo 1: Calcular o Valor Total Inicial (R$)</strong
                  ><br />
                  Multiplicamos o preço unitário pela quantidade de produtos:
                  <br />
                  <code
                    >{{ produtoSelecionado.preco }} x
                    {{ produtoSelecionado.qtde }} =
                    {{ produtoSelecionado.valorcalclista }}</code
                  >
                </p>
                <p>
                  <strong>Passo 2: Calcular o Valor do Desconto (R$)</strong
                  ><br />
                  Aplicamos o percentual de desconto sobre o valor total
                  inicial:
                  <br />
                  <code
                    >({{ produtoSelecionado.valorcalclista }} x
                    {{ produtoSelecionado.percdesconto }}%) / 100 =
                    {{ produtoSelecionado.valordesconto }}</code
                  >
                </p>
                <p>
                  <strong>Passo 3: Calcular o Novo Valor Unitário (R$)</strong
                  ><br />
                  Subtraímos o valor do desconto do valor total inicial e
                  dividimos pela quantidade de produtos:
                  <br />
                  <code
                    >({{ produtoSelecionado.valorcalclista }} -
                    {{ produtoSelecionado.valordesconto }}) /
                    {{ produtoSelecionado.qtde }} =
                    {{
                      (produtoSelecionado.valorcalclista -
                        produtoSelecionado.valordesconto) /
                      produtoSelecionado.qtde
                    }}</code
                  >
                </p>
                <p>
                  <strong>Passo 4: Calcular os Juros (R$)</strong><br />
                  <template v-if="produtoSelecionado.acrescimoperc > 0">
                    <span v-if="getTipoPedidoSelec.contrato">
                      Aplicamos o percentual de acréscimo sobre o valor
                      unitário:
                      <br />
                      <code
                        >{{ produtoSelecionado.vlrunitario }} + ({{
                          produtoSelecionado.acrescimoperc
                        }}% x {{ produtoSelecionado.vlrunitario }}) / 100 =
                        {{
                          produtoSelecionado.vlrunitario +
                          (produtoSelecionado.acrescimoperc *
                            produtoSelecionado.vlrunitario) /
                            100
                        }}</code
                      >
                    </span>
                    <span v-else>
                      Calculamos os juros para cada parcela e atualizamos o
                      valor unitário:
                      <br />

                      <div
                        class="ml-4"
                        v-for="parcela in produtoSelecionado.parcelas"
                        :key="parcela.parcela"
                      >
                        <strong>{{ parcela.parcela }}</strong>

                        <ul>
                          <li>Dias: {{ parcela.dias }}</li>
                          <li>Percentual: {{ parcela.perc }}%</li>
                          <li>Valor Acréscimo: R$ {{ parcela.vlr_acresc }}</li>
                          <li>Valor Total: R$ {{ parcela.vlr_total }}</li>
                        </ul>
                      </div>
                      <div
                        class="ml-4 mt-4"
                        v-if="produtoSelecionado.parcelas.length > 0"
                      >
                        <span
                          >Depois dividimos o valor total pelo número de
                          parcelas:</span
                        ><br />
                        <code
                          >{{
                            produtoSelecionado.parcelas[
                              produtoSelecionado.parcelas.length - 1
                            ].vlr_total
                          }}
                          / {{ produtoSelecionado.numparcelas }}</code
                        >
                        <br />
                        Valor unitário atualizado:
                        <br />
                        <code>{{
                          produtoSelecionado.parcelas[
                            produtoSelecionado.parcelas.length - 1
                          ].vlr_total / produtoSelecionado.numparcelas
                        }}</code>
                      </div>
                    </span>
                  </template>
                  <code v-else>Não Há</code>
                </p>
                <p>
                  <strong>Passo 5: Calcular a Tributação Fora UF (R$)</strong
                  ><br />
                  Aplicamos o percentual de tributação fora UF sobre o valor
                  unitário:
                  <br />

                  <code v-if="produtoSelecionado.perctributaforauf > 0"
                    >{{ produtoSelecionado.vlrunitario }} + ({{
                      produtoSelecionado.perctributaforauf
                    }}% x {{ produtoSelecionado.vlrunitario }}) / 100 =
                    {{
                      produtoSelecionado.vlrunitario +
                      (produtoSelecionado.vlrunitario *
                        produtoSelecionado.perctributaforauf) /
                        100
                    }}</code
                  >
                  <code v-else>Não Há</code>
                </p>
                <p>
                  <strong
                    >Passo 6: Calcular o Diferimento de Tributação (R$)</strong
                  ><br />
                  Aplicamos o percentual de diferimento de tributação sobre o
                  valor unitário:
                  <br />
                  <code v-if="produtoSelecionado.perctributadiferimento > 0"
                    >{{ produtoSelecionado.vlrunitario }} + ({{
                      produtoSelecionado.perctributadiferimento
                    }}% x {{ produtoSelecionado.vlrunitario }}) / 100 =
                    {{
                      produtoSelecionado.vlrunitario +
                      (produtoSelecionado.vlrunitario *
                        produtoSelecionado.perctributadiferimento) /
                        100
                    }}</code
                  ><code v-else>Não Há</code>
                </p>
                <p v-if="cobrarFrete">
                  <strong>Passo 7: Calcular o Frete (R$)</strong><br />
                  Calculamos o valor do frete com base na quantidade (kg):
                  <br />
                  <code
                    >{{ getValorFrete().valor_kg }} x
                    {{ produtoSelecionado.qtdekgs }} =
                    {{
                      (
                        getValorFrete().valor_kg * produtoSelecionado.qtdekgs
                      ).toFixed(2)
                    }}</code
                  >
                  <span v-if="novopedido.cliente.vlrdescfrete > 0">
                    <br />
                    Aplicamos o desconto no frete:
                    <br />
                    <code
                      >({{ getValorFrete().valor_kg }} -
                      {{ novopedido.cliente.vlrdescfrete }} / 1000) x
                      {{ produtoSelecionado.qtdekgs }} =
                      {{ produtoSelecionado.valorliqfrete }}</code
                    >
                  </span>
                </p>
                <p>
                  <strong>Passo 8: Calcular o Valor Total do Item (R$)</strong
                  ><br />
                  Multiplicamos o valor unitário pela quantidade e adicionamos o
                  frete:
                  <br />
                  <code
                    >{{ produtoSelecionado.vlrunitario }} x
                    {{ produtoSelecionado.qtde }} +
                    {{
                      produtoSelecionado.valorliqfrete > 0
                        ? produtoSelecionado.valorliqfrete
                        : produtoSelecionado.valorfrete
                    }}
                    = {{ produtoSelecionado.valortotalitem }}</code
                  >
                </p>
                <p>
                  <strong
                    >Passo 9: Calcular o Valor Unitário com Frete (R$)</strong
                  ><br />
                  Dividimos o valor total do item pela quantidade:
                  <br />
                  <code
                    >{{ produtoSelecionado.valortotalitem }} /
                    {{ produtoSelecionado.qtde }} =
                    {{
                      produtoSelecionado.valortotalitem /
                      produtoSelecionado.qtde
                    }}</code
                  >
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false" color="secondary" text rounded block
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatMoeda } from "@/global";

export default {
  computed: { ...mapState("pedidos", ["produtoSelecionado", "novopedido"]) },
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapGetters("pedidos", [
      "getTipoPedidoSelec",
      "cobrarFrete",
      "getValorFrete",
      "getParcelas",
    ]),
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style scoped>
code {
  font-size: 1.1rem !important;
  font-weight: bold !important;
  font-family: "Courier New", Courier, monospace !important;
}
strong {
  font-size: 1rem !important;
  color: rgb(65, 59, 59);
}
</style>